import React, {Component} from 'react'
import PropTypes from 'prop-types'
import JobTableRow from "./JobTableRow"

class JobTableBody extends Component {
    render() {
        const {listSession, reloadListSessions} = this.props

        return (
            <tbody>
            {
                listSession.length > 0 ? listSession.map((item, index) => {
                        return <JobTableRow key={item._id} index={index} item={item} reloadListSessions={reloadListSessions}/>
                    })
                    : <tr>
                        <td colSpan={6}>Không có dữ liệu</td>
                    </tr>
            }
            </tbody>
        )
    }
}

JobTableBody.propTypes = {
    listSession: PropTypes.array.isRequired,
    reloadListSessions: PropTypes.func.isRequired
}

export default JobTableBody